import { configureStore, applyMiddleware } from "@reduxjs/toolkit";
import clients from "./reducerSlice/clients";
import wards from "./reducerSlice/wards";
import beds from "./reducerSlice/beds";
import auditTrails from "./reducerSlice/auditTrails";
import dashboards from "./reducerSlice/dashboards";
import workForces from "./reducerSlice/workForces";
import reports from "./reducerSlice/reports";
import locations from "./reducerSlice/locations";
import conditions from "./reducerSlice/conditions";
import ucrts from "./reducerSlice/ucrts";
import imcs from "./reducerSlice/imc";
import user, { checkUser } from "./reducerSlice/user";
import admin, { checkAdmin } from "./reducerSlice/admin";
import { getProfile } from "./actions/adminAction";

const store = configureStore({
  reducer: {
    user,
    admin,
    clients,
    conditions,
    wards,
    beds,
    auditTrails,
    dashboards,
    workForces,
    reports,
    ucrts,
    locations,
    imcs
  },
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api)
});

const authDetail = localStorage.getItem("authorization");
store.dispatch(checkAdmin(authDetail));
// if(authDetail) {
// store.dispatch(getProfile());
// }

export default store;
